import { FC } from 'react';
import { ClaimsLayout } from 'pages/atoms';
import { ClaimsSettings } from 'containers/claims';

const ClaimsSettingsPage: FC = () => {
  return (
    <ClaimsLayout>
      <ClaimsSettings />
    </ClaimsLayout>
  );
};

export default ClaimsSettingsPage;
